export const PostsRoute = {
  PostDetail: 'post-detail',
  PostSearch: 'post-search',
  HappeningParticipants: 'happening-participants'
} as const;

export type PostsRoute = (typeof PostsRoute)[keyof typeof PostsRoute];

export type PostsParam = {
  [PostsRoute.PostDetail]: { id?: string };
  [PostsRoute.PostSearch]: undefined;
  [PostsRoute.HappeningParticipants]: {
    postId?: string;
    participantCount?: number;
  };
};
